import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DashboardFinanceiro from "../../components/financeiro/DashboardFinanceiro";
import GraficosFinanceiros from "../../components/financeiro/graficos/GraficosFinanceiros";
import {
  dashboardFinanceiroService,
  DashboardFinanceiroResponse,
} from "../../services/dashboardfinanceiro";

const DashFinanceiro: React.FC = () => {
  const [dados, setDados] =
    useState<DashboardFinanceiroResponse | null>(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function carregarDashboard() {
      try {
        const response =
          await dashboardFinanceiroService.getDashboardFinanceiro();

        setDados(response);
      } catch (error) {
        console.error("Erro ao carregar dashboard financeiro:", error);
        toast.error("Erro ao carregar o dashboard financeiro.");
      } finally {
        setLoading(false);
      }
    }

    carregarDashboard();
  }, []);

  if (loading) {
    return <p className="text-gray-500">Carregando dashboard...</p>;
  }

  if (!dados) {
    return (
      <p className="text-red-500">
        Erro ao carregar dados do dashboard
      </p>
    );
  }

  /* =======================
     MAPEAMENTOS PARA GRÁFICOS
  ======================= */

  // Top 5 franquias
  const receitaPorFranqueado = dados.top_5.map(item => ({
    name: item.nome,
    value: item.valor,
  }));

  // Status de pagamento
  const statusPagamentos = [
    {
      name: "Pagos",
      value: dados.proporcao_pagamento.pago_percent,
    },
    {
      name: "Pendentes",
      value: dados.proporcao_pagamento.pendente_percent,
    },
  ];

  return (
    <div className="space-y-6">
      <DashboardFinanceiro
        titulo="Dashboard Financeiro"
        subtitulo="Acompanhe os resultados do seu negócio"
        receitaTotal={`R$ ${Number(dados.total_receita).toFixed(2)}`}
        clientesAtivos={String(dados.total_clientes)}
        pagamentosPendentes={String(
          Math.trunc(Number(dados.pagamentos_pendentes.quantidade))
        )}
        rotaRelatorio="/financeiro/franqueado/relatorios"
      />

      <GraficosFinanceiros
        receitaPorFranqueado={receitaPorFranqueado}
        statusPagamentos={statusPagamentos}
      />
    </div>
  );
};

export default DashFinanceiro;
